"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftTransferDocumentBuilder = void 0;
var LogRelatedId_1 = require("../common/LogRelatedId");
var NftTransferDocumentBuilder = /** @class */ (function () {
    function NftTransferDocumentBuilder() {
    }
    NftTransferDocumentBuilder.build = function (transfer, block, confirmed, chainId) {
        var chain = Number(chainId);
        var document = {
            id: LogRelatedId_1.LogRelatedId.create(chain, transfer.transactionHash, transfer.logIndex),
            transactionHash: transfer.transactionHash,
            contract: transfer.contract,
            logIndex: transfer.logIndex,
            operator: transfer.operator,
            from: transfer.from,
            to: transfer.to,
            tokenId: transfer.tokenId,
            amount: transfer.amount,
            tokenContractType: transfer.tokenContractType,
            tokenName: transfer.tokenName,
            tokenSymbol: transfer.tokenSymbol,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain,
        };
        return document;
    };
    return NftTransferDocumentBuilder;
}());
exports.NftTransferDocumentBuilder = NftTransferDocumentBuilder;
//# sourceMappingURL=NftTransferDocumentBuilder.js.map